import $ from 'jquery';
import Truncate from '../ui/truncate';
import {Collection} from '../ui/collection';
import FilterCanvas from '../ui/filter-canvas';
import '../app-extends/wishlist-plus/product-card';
import '../../styles/templates/collection.scss';

/**
 * Truncations
 */
$('.truncation').each((_, item) => {
  new Truncate(item);
});

/**
 * Collection
 */
new Collection('.collection');

/**
 * Filter Canvas
 */
new FilterCanvas('.filters');






document.addEventListener("DOMContentLoaded", (event) => {

  const quickBuyButtons = document.querySelectorAll('.quick-button');
  const quickBuyForms = document.querySelectorAll('.quick-buy-form');
  const body = document.querySelector('body');
  const quickButtonsMobile = document.querySelectorAll('.quick-button__mobile');
  const quickBuyClose = document.querySelectorAll('.close-btn');

  //get the appropriate quick buy form to open using index

  quickBuyButtons.forEach((quickBuyButton) => {
    quickBuyButton.addEventListener('click', () => {
      const buttonIndex = quickBuyButton.dataset.index;
      quickBuyForms.forEach((quickBuyForm) => {
        const formIndex = quickBuyForm.dataset.index
        if (buttonIndex === formIndex) {
          quickBuyForm.classList.add('active');
        }
      });
      body.classList.toggle('popup-active');
    });
  }
  );

  quickButtonsMobile.forEach((quickButtonMobile) => {
    quickButtonMobile.addEventListener('click', () => {
      const buttonIndex = quickButtonMobile.dataset.index;
      quickBuyForms.forEach((quickBuyForm) => {
        const formIndex = quickBuyForm.dataset.index
        if (buttonIndex === formIndex) {
          quickBuyForm.classList.add('active');
        }
      });
      body.classList.add('popup-active');
    });
  });

  quickBuyClose.forEach((quickBuyClose) => {
    quickBuyClose.addEventListener('click', () => {
      quickBuyForms.forEach((quickBuyForm) => {
        quickBuyForm.classList.remove('active');
      });
      body.classList.remove('popup-active');
    });
  });

  // if quick buy form is open and user clicks outside of it, close it

  body.addEventListener('click', (event) => {
    if (event.target.classList.contains('popup-active')) {
      quickBuyForms.forEach((quickBuyForm) => {
        quickBuyForm.classList.remove('active');
      });
      body.classList.remove('popup-active');
    }
  });
});
